import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { phoneNumberFormSchema } from '@/_schemas/phone-numbers';

import { defaultValues } from './model';

export function useFormDefinition(v = defaultValues) {
  return useForm({
    resolver: zodResolver(phoneNumberFormSchema),
    defaultValues: v,
  });
}
